 document.addEventListener('DOMContentLoaded', function () {
    $('.testimonial-slider').slick({
      dots: true,
      arrows: false,
      autoplay: true,
      infinite: true,
      slidesToShow: 1,
      slidesToScroll: 1,
    });
  });


document.addEventListener('DOMContentLoaded', function () {
    document.querySelectorAll('.read-more-toggle').forEach(function (btn) {
      btn.addEventListener('click', function () {
        const gallerySelector = btn.getAttribute('data-gallery');
        const gallery = document.querySelector(gallerySelector);

        if (gallery) {
          gallery.classList.toggle('show-all');
          btn.textContent = gallery.classList.contains('show-all') ? 'SHOW LESS' : 'SHOW MORE';
        }
      });
    });
  });



  